import React from 'react';
import { createPortal } from 'react-dom';
import './InfoModal.css';

// Popup genérico de explicação — usado nos mini gráficos da aba Saúde, no
// card de Recuperação e nos cards de Treino, pra explicar o que cada
// indicador significa ou como uma classificação é calculada.
//
// Renderizado via portal direto no <body>: os cards (.card) têm um efeito
// de "aperto" no :active (transform: scale(0.98)) que se propaga pros
// ancestrais durante qualquer toque num descendente. Se o popup ficasse
// dentro da árvore do card, esse transform vira o "containing block" do
// position:fixed enquanto o dedo está apertado, deslocando o popup inteiro
// bem na hora do toque — o toque solta num lugar errado e o botão de
// fechar/tocar fora nunca acerta. Fora da árvore, isso não acontece.
function InfoModal({ title, children, onClose }) {
  return createPortal(
    <div className="im-backdrop" onClick={onClose}>
      <div className="im-modal" onClick={(e) => e.stopPropagation()}>
        <div className="im-head">
          <h3>{title}</h3>
          <button className="im-close" onClick={onClose} aria-label="Fechar">✕</button>
        </div>
        <div className="im-body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}

// Botão "ⓘ" reutilizável — abre o InfoModal quando clicado.
export function InfoButton({ onClick, style }) {
  return (
    <button
      type="button" className="im-trigger" onClick={onClick} style={style}
      aria-label="Explicação"
    >
      ⓘ
    </button>
  );
}

export default InfoModal;
